/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import booth from "../../images/booth_info_re.svg"
import booth_en from "../../images/booth_info_re_en.svg"


import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

const ContactBooth = () => {
    return(
        <div className="sect-01-box-01-exhibitor-regi">
            <div className="sect-tit">{t("exh_regi_booth_title")}</div>
            <div className='exhibitor-regi-booth-img-wrap' style={{textAlign:"center"}}>
                <div className='w-full md:w-10/12' style={{maxWidth:"1500px", display:"inline-block"}}>
                    {
                        t("lang") === "ko"
                        ?<img src={booth}/>
                        :<img src={booth_en}/>
                    }
                    
                </div>
            </div>
        </div>
    )
}

export default ContactBooth;